export const  style = {                     
    minWidth: '300px',
    minHeight: '55px',
    border: '3px solid #1793af',
    padding: '16px',
    color: '#fff',
    background: '#000',
    
}

export const iconTheme = {
    primary: '#FF67FF' ,
    secondary: '#000',
}

export const  position= {
    position: "bottom-center"
}